import { Component, Input, OnInit } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable, of } from 'rxjs';

import { Search } from '../../../models';
import { BaseEditService, FormlyService, ModalService } from '../../../services';

@Component({
  selector: 'app-search-modal',
  templateUrl: './search-modal.component.html',
  styleUrl: './search-modal.component.scss',
})
export class SearchModalComponent implements OnInit {
  @Input() stateKey: string;
  @Input() header = '';
  @Input() allLabel = $localize`All`;
  @Input() id: string;
  @Input() columnDefs: ColDef[] = [];
  @Input() createComponent: any;
  @Input() service: BaseEditService<any, any>;
  @Input() results$: Observable<any[]> = of([]);
  @Input() model: Search = {} as Search;
  @Input() showSave = true;

  fields: FormlyFieldConfig[];

  constructor(
    private modalService: ModalService,
    private formlyService: FormlyService,
  ) {}

  ngOnInit() {
    this.getFields();
  }

  get gridStateKey() {
    return `SearchModal.${this.stateKey ?? this.header}`;
  }

  edit(model: any) {
    this.modalService.close(model);
  }

  clearSearch(searchBox: HTMLInputElement) {
    searchBox.value = '';
    searchBox.focus();
  }

  private getFields() {
    this.fields = [
      this.formlyService.search(
        'search',
        '',
        this.service,
        (results: Observable<any[]>) => (this.results$ = results),
        undefined,
        undefined,
        {
          'props.id': (field: FormlyFieldConfig) => (field.model?.includeAll ? undefined : this.id),
        },
      ),
    ];

    if (this.id && this.allLabel) {
      this.fields.push(this.formlyService.checkbox('includeAll', this.allLabel));
    }

    if (this.createComponent) {
      this.fields.push(this.formlyService.createButton(() => this.create()));
    }
  }

  private create() {
    const { modal, component } = this.modalService.openXL<any>(this.createComponent);
    component.id = this.id;
    modal.result.then(
      (result) => this.modalService.close(result),
      () => {},
    );
  }
}
